import { createWidget } from '@alfa-bank/site-util-create-widget';

import { HashField as Component } from './hash-field';
import type { IProps } from './models';

export const HashField = createWidget<unknown, IProps>()(Component);
